import React from 'react';

interface MoneyIconProps {
  className?: string;
}

export const MoneyIcon = ({ className }: MoneyIconProps) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="9" stroke="#999999" strokeWidth="2" />
    <path
      d="M9.10742 10.9951L9.15527 12.1982C9.15527 12.8135 9.00944 13.3148 8.71777 13.7021H13.4756L13.4688 15.083H6.29785V13.7021H6.8584C7.03613 13.6611 7.17285 13.5153 7.26855 13.2646C7.36882 13.0094 7.41895 12.6745 7.41895 12.2598L7.37109 10.9951H6.27051V9.63477H7.33008L7.27539 7.98047C7.27539 7.0599 7.56022 6.33301 8.12988 5.7998C8.69954 5.2666 9.44694 5 10.3721 5C11.2972 5 12.0241 5.24837 12.5527 5.74512C13.0814 6.24186 13.3457 6.90951 13.3457 7.74805H11.6709C11.6709 7.3151 11.5501 6.98014 11.3086 6.74316C11.0716 6.50163 10.7389 6.38086 10.3105 6.38086C9.90495 6.38086 9.58366 6.52897 9.34668 6.8252C9.11426 7.12142 8.99805 7.50651 8.99805 7.98047L9.05957 9.63477H11.1855V10.9951H9.10742Z"
      fill="#999999"
    />
  </svg>
);
